import { memo } from 'react'

import ViewMasterPage, { TEST_ID } from './ViewMaster'

const ViewMaster = memo(ViewMasterPage)

export { TEST_ID }

export default ViewMaster
